export const Modal = {
    OPEN: "modal.open",
    CLOSE: "modal.close",
    UPDATE: "modal.update",
    CLOSE_ALL: "modal.close_all",
};

export const ModalTypes = {
    INVENTORY_LOADER: "inventory.loader",
};
